import { NgModule } from '@angular/core';
import { AlertBoxComponent } from './alert-box.component';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    AlertBoxComponent
  ],
  exports: [
    AlertBoxComponent
  ]
})
export class AlertBoxModule {}
